import {
  Forbidden,
  PageNotFound,
} from '@risksmart-app/components/src/errors/errors';
import type { ErrorEvent, EventHint } from '@sentry/react';
import type { AxiosError } from 'axios';
import { isAxiosError } from 'axios';

export const addAxiosContext = (event: ErrorEvent, error: AxiosError) => {
  if (error.response) {
    const contexts = { ...event.contexts };
    contexts.Axios = { Response: error.response };
    event.contexts = contexts;
  }
};

export const addAxiosContextRecursive = (event: ErrorEvent, error: unknown) => {
  if (isAxiosError(error)) {
    addAxiosContext(event, error);
  } else if (error instanceof Error && error.cause) {
    addAxiosContextRecursive(event, error.cause);
  }
};

export const isExpectedRouteError = (error: unknown): boolean => {
  if (error instanceof PageNotFound || error instanceof Forbidden) {
    return true;
  }
  if (error instanceof Error && error.cause) {
    return isExpectedRouteError(error.cause);
  }

  return false;
};

export const handleSentryBeforeSend = (event: ErrorEvent, hint: EventHint) => {
  if (isExpectedRouteError(hint?.originalException)) {
    return null;
  }

  addAxiosContextRecursive(event, hint?.originalException);

  return event;
};
